import * as angular from 'angular';
import * as _ from 'lodash';

import { configModes } from '../../common/ConfigModes';
import { ComponentDefinition } from '../../models';

class ValidationConfigModeSelector implements angular.IComponentController {
    configModes: { value: number, name: string }[];
    model: string;
    onChange: ({ value: any }) => void;

    static $inject = [];

    $onInit() {
        const modes = [];
        for (const key of Object.keys(configModes)) {
            modes.push({
                value: parseInt(key),
                name: configModes[key]
            });
        }
        this.configModes = modes;
    }
    changed() {
        if (this.onChange) {
            this.onChange({ value: this.model });
        }
    }
}

export const wtValidationConfigModeSelector: ComponentDefinition = {
    componentId: 'wtValidationConfigModeSelector',
    controller: ValidationConfigModeSelector,
    template: require('./validationConfigModeSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        isDisabled: '<?',
        model: '=',
        onChange: '&?'
    }
};